import { AccountDetailProcessMonitorDTO, AccountProcessMonitorStatusDTO, BrokerConfigProcessMonitorDTO, BrokerDetailProcessMonitorDTO, BrokerProcessMonitorDTO, BrokerProcessMonitorStatusDTO, ExecutionLogDTO, ExecutionStatusDTO, MonitorCodeDTO } from "./DTO"
import { AccountDetailProcessMonitor, AccountProcessMonitorStatus, BrokerConfigProcessMonitor, BrokerDetailProcessMonitor, BrokerProcessMonitor, BrokerProcessMonitorStatus, ExecutionLog, ExecutionStatus, MonitorCode } from "../../../@type/broker-hub/broker-hub"

export const mapperBrokerProcessMonitorDTOToModel = (b: BrokerProcessMonitorDTO): BrokerProcessMonitor => ({
    BrokerID: b.i,
    Name: b.n,
    LastDate: b.l,
    PendingProcess: b.p,
    ExternalCode: b.e,
    Config: b.c.map(mapperBrokerConfigProcessMonitorDTOToModel),
    Status: b.s.map(mapperBrokerProcessMonitorStatusDTOToModel),
    Detail: b.d.map(mapperBrokerDetailProcessMonitorDTOToModel),
    Accounts: b.a.map(mapperAccountProcessMonitorStatusDTOToModel)
});

const mapperBrokerConfigProcessMonitorDTOToModel = (c: BrokerConfigProcessMonitorDTO): BrokerConfigProcessMonitor => ({
    TypeID: c.i,
    TypeName: c.n
});

const mapperBrokerProcessMonitorStatusDTOToModel = (s: BrokerProcessMonitorStatusDTO): BrokerProcessMonitorStatus => ({
    TypeName: s.t,
    TypeID: s.p,
    Status: s.s,
    date: s.d
});

const mapperBrokerDetailProcessMonitorDTOToModel = (d: BrokerDetailProcessMonitorDTO): BrokerDetailProcessMonitor => ({
    date: d.d,
    Trades: d.t,
    Opens: d.o
});

const mapperAccountProcessMonitorStatusDTOToModel = (a: AccountProcessMonitorStatusDTO): AccountProcessMonitorStatus => ({
    Account: a.a,
    History: a.h,
    LastImport: a.i,
    LastTrade: a.t,
    Matches: a.m,
    PendingMatches: a.p,
    Fusion: a.f,
    Detail: a.d.map(mapperAccountDetailProcessMonitorDTOToModel)
});

const mapperAccountDetailProcessMonitorDTOToModel = (d: AccountDetailProcessMonitorDTO): AccountDetailProcessMonitor => ({
    FutureMatches: d.f,
    OptionExercise: d.e,
    OptionExpire: d.x,
    OptionMatches: d.m,
    Trades: d.t,
    Opens: d.o,
    date: d.d
});

export const mapperExecutionStatusDTOToModel  = (d: ExecutionStatusDTO): ExecutionStatus => ({
    ExecutionID: d.i, 
    Functions: d.f,
    Brokers: d.b,
    ProcessType: d.p,
    FileName: d.n,
    Accounts: d.a,
    Result: d.r,
    Errors: d.e,
    Warnings: d.w,
    Start: d.s,
    End: d.d,
    Elapsed: d.t,
    LastError: d.x,
    LastWarning: d.y,
    NoCheck: d.z,
    Resolve: d.v,

    FunctionsSearch: d.fs,
    BrokersSearch: d.bs,
    ProcessTypesSearch: d.ps,
    FileNamesSearch: d.ns,
    AccountsSearch: d.as
});

export const mapperExecutionLogDTOToModel = (l: ExecutionLogDTO) : ExecutionLog => ({
    id: l.i,
    BrokerID: l.b,
    Broker: l.bn,
    ProcessTypeID: l.p,
    ProcessType: l.pn,
    Cob: l.c,
    MonitorCodeID: l.m,
    MonitorCode: mapperMonitorCodeDTOToModel(l.md),
    UserID: l.u,
    User: l.um,
    TimeStamp: l.t,
    Comment: l.x,
    ExtraInfo: l.y,
    Metric: l.z,
    IsResolved: l.r,
    ResolvedTimeStamp: l.rt,
    ResolvedComment: l.rc,
    ExecutionID: l.g,
    FileName: l.f,
    Account: l.a,
    Ref1: l.r1,
    Ref2: l.r2
});

const mapperMonitorCodeDTOToModel = (c : MonitorCodeDTO) : MonitorCode => ({
    CheckAction: c.a,
    CheckProcessAction: c.c,
    CodeID: c.i,
    DataMetric: c.d,
    Description: c.n,
    Function: c.f,
    MonitorAlertLevelID: c.l,
    Origin: c.o,
    Reprocess: c.r,
    RequireAction: c.t,
    UserActions: c.u,
    Ref1: c.r1,
    Ref2: c.r2
});